// Character count, plus (for scripts) how many spoken words fit the planned video at ~2 words/second.
export const TextMeter = ({ text = "", max, id, seconds }) => {
  const chars = (text || "").length;
  const words = (text || "").trim() ? text.trim().split(/\s+/).length : 0;
  const fit = seconds ? Math.max(0, Math.floor(seconds * 2)) : null;
  const over = fit !== null && words > fit;
  return (
    <span className="sw-text-meter" data-testid={`${id}-text-meter`} style={{ display: "flex", justifyContent: "space-between", gap: 12, fontSize: 12, opacity: 0.75, marginTop: 4, fontWeight: 400 }}>
      <span data-testid={`${id}-char-count`}>{chars.toLocaleString()} / {max.toLocaleString()} characters</span>
      {fit !== null && words > 0 && (
        <span data-testid={`${id}-fit-hint`} style={over ? { color: "#d97706", opacity: 1 } : undefined}>
          {words.toLocaleString()} words · ~{fit} fit a {seconds}-second video{over ? " — the Director will condense it" : ""}
        </span>
      )}
    </span>
  );
};
